var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Journey-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.5-Uploaded-state-\\u2014-edited",
    transform: "translate(-740.000000, -350.000000)",
    stroke: "#373737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(715.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(26.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "document_20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.308571429,6.53142857 L5.39027027,6.53142857 C6.02998234,6.53142857 6.54857143,6.07612493 6.54857143,5.51447942 L6.54857143,0.531428571 M17.675314,16.8156285 L17.675314,22.614215 C17.675314,23.1996759 17.1943307,23.6742857 16.6010078,23.6742857 L0.765734749,23.6742857 C0.17241183,23.6742857 -0.308571429,23.1996759 -0.308571429,22.614215 L-0.308571429,5.92870268 L6.05132114,-0.325714286 L16.6171224,-0.325714286 C17.2104453,-0.325714286 17.6914286,0.14889552 17.6914286,0.734356386 L17.6914286,5.94990409 L17.675314,16.8156285 Z",
    id: "Path-2",
    transform: "translate(9.000000, 12.000000) scale(-1, 1) translate(-9.000000, -12.000000) "
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.22b1e0537c4a8f3db6bab953e0add8fa.svg";
export { ForwardRef as ReactComponent };